import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const DoubleQuoteMika = ({ size = 39, style = {} }: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={(size / 39) * 29}
      viewBox="0 0 39 29"
      style={style}
      fill="none"
    >
      <path
        d="M13.958 26.68C12.355 28.227 10.322 29 7.85901 29C5.435 29 3.51898 28.111 2.11102 26.332C0.703979 24.553 0 21.383 0 16.82C0 12.219 3.04999 6.612 9.14899 0L14.427 3.77C12.472 7.55901 11.241 10.769 10.732 13.398C12.414 13.939 13.782 14.906 14.838 16.298C15.854 17.69 16.362 19.391 16.362 21.402C16.362 23.374 15.561 25.133 13.958 26.68ZM36.654 26.622C35.09 28.169 33.096 28.942 30.672 28.942C28.248 28.981 26.332 28.111 24.925 26.332C23.517 24.553 22.814 21.363 22.814 16.762C22.814 12.122 25.824 6.535 31.845 0L37.241 3.77C35.168 7.405 33.937 10.614 33.546 13.398C35.188 13.939 36.517 14.906 37.534 16.298C38.511 17.651 39 19.256 39 21.112C39 21.189 39 21.731 39 22.736C39 23.78 38.218 25.075 36.654 26.622Z"
        fill="url(#paint0_linear_80_15828)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_80_15828"
          x1="18.0175"
          y1="22.3077"
          x2="18.0175"
          y2="7.02692"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EF89E4" />
          <stop offset="0.965" stop-color="#BC5BEB" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DoubleQuoteMika;
